import React from "react";
import { Link } from "react-router-dom";
import "./MembershipHomeStyles.css";
import ShikhaaLogo from "../../../Assets/Cover/Shikhaa_Logo.png";
import membershipImage from "../../../Assets/Membership/Membership_Home_003.png";
import formImage from "../../../Assets/Membership/Membership_Home_001.png";
import volunteerImage from "../../../Assets/Membership/Membership_Home_002.png";

const MembershipHome = () => {
  return (
    <div className="summary-container">
      <img
        src={ShikhaaLogo}
        alt="Shikhaa The Light Logo"
        className="mem-home-fobana_logo"
      />

      <h1>WELCOME TO SHIKHAA MEMBERSHIP PORTAL</h1>

      <p className="intro-text">
        Join Shikhaa – The Light and become part of a community-driven
        organization dedicated to preserving Bangladeshi culture, heritage, and
        identity in South Florida. Through cultural education, community
        programs, and events like the annual Pitha Festival, Shikhaa works to
        spread the light of culture and togetherness among present and future
        generations.
      </p>

      <div className="summary-section">
        <img
          src={membershipImage}
          alt="Membership Benefits"
          className="summary-image"
        />
        <div className="summary-text">
          <h2>Shikhaa Membership Benefits</h2>
          <p>
            Becoming a member of Shikhaa – The Light gives you the opportunity
            to actively support Bangladeshi cultural preservation, community
            engagement, youth involvement, and educational activities. Members
            can participate in cultural events, volunteer programs, community
            celebrations, and initiatives that strengthen the bond among
            Bangladeshi families in South Florida.
          </p>
          {/* <Link to="/membersBenefit" className="read-more-btn">
            Learn More
          </Link> */}
        </div>
      </div>

      <div className="summary-section-membership">
        <img src={formImage} alt="Membership Form" className="summary-image" />
        <div className="summary-text">
          <h2>How to Apply for Membership?</h2>
          <p>
            The membership application process is simple. Interested individuals
            and families may complete the membership form, provide the required
            contact information, and submit their application for review.
            Membership allows community members to stay connected with Shikhaa’s
            upcoming programs, cultural activities, and volunteer opportunities.
          </p>
          <Link to="/membershipForm" className="read-more-btn">
            Become a Proud Member
          </Link>
        </div>
      </div>

      <div className="summary-section">
        <img
          src={volunteerImage}
          alt="Volunteer and Leadership Opportunities"
          className="summary-image"
        />
        <div className="summary-text">
          <h2>Volunteer and Leadership Opportunities</h2>
          <p>
            Shikhaa – The Light welcomes community members who wish to take an
            active role in organizing cultural programs, supporting the annual
            Pitha Festival, guiding youth activities, and promoting Bangladeshi
            heritage. Volunteers and leaders play an important role in helping
            Shikhaa spread the light of culture, education, and unity throughout
            the community.
          </p>
          <Link to="/about" className="read-more-btn">
            Learn About Opportunities
          </Link>
        </div>
      </div>
    </div>
  );
};

export default MembershipHome;
